<template>
  <div>
    <div v-if="!isLoading && addonNeeded">
      <locked
        title="Individual Participants data"
        secondary-title="Per participant, you’ll get:"
        addon-name="Individual Participants data Addon"
        description="Purchase this add-on to access more data in your report."
        :info-items="[
          'Emotion recording & eye tracking video',
          'Demographics',
          'Associations',
          'Evaluation scores and additional comments',
          'Open questions',
        ]"
        price="900,-"
        :show-icon="false"
      ></locked>
    </div>

    <div v-if="!isLoading && !addonNeeded">
      <h1 v-bg-typography="'h1'">Participants</h1>
      <bg-loader :dark="true" v-if="isLoading"></bg-loader>
      <bg-new-list
        v-if="!isLoading"
        :headers="headers"
        :items="participants"
        :actions="actions"
        @actionClick="handleActions"
        :actionPerms="true"
      />
    </div>
  </div>
</template>

<style scoped></style>

<script>
import BgNewList from "@/components/bg-new-list";
import BgTypography from "@/directives/bg-typography";
import API from "@/api";
import BgLoader from "@/components/bg-loader";
import Locked from "@/components/base-locked";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "participants",
  components: {
    BgLoader,
    BgNewList,
    Locked,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      addonNeeded: false,
      isLoading: true,
      data: null,
      participants: [],
      dropdownValue: false,
      actions: [
        {
          type: "favourite",
          icon: "star",
          tooltip: "Favourite",
        },
        {
          type: "video",
          text: "View",
        },
      ],
      headers: [
        {
          value: "id",
          icon: "account",
          format: (value) => `Participant ${value}`,
          color: "#B50073",
        },
        {
          value: "age",
          label: "Age",
        },
        {
          value: "gender",
          label: "Gender",
          format: (value) => value.replace(/^\w/, (c) => c.toUpperCase()),
        },
        {
          value: "education",
          label: "Education",
        },
      ],
    };
  },
  mounted() {
    API.test.getTest(this.$route.params.id).then((res) => {
      this.isLoading = false;
      if (!res.addons.includes("individual_participant")) {
        this.addonNeeded = true;
      }
      const withTtc = res.participants
        .filter((p) => p.type === "default")
        .map((p) => {
          return {
            ...p,
            ...p.demographic,
            time_to_complete: this.timeToComplete(p),
            link: `/video-test/${this.$route.params.id}/participant/${p.id}`,
          };
        });
      this.participants = withTtc;
    });
  },
  methods: {
    handleActions(participant) {
      if (participant.actionType === "video") {
        this.$router.push({
          path: `/video-test/${this.$route.params.id}/participant/${participant.id}`,
        });
      }
    },
    timeToComplete(p) {
      const startTime = moment(p.started_at);
      const endTime = moment(p.ended_at);
      const diff = endTime.diff(startTime);
      return moment(diff).format("mm:ss");
    },
    handleSelectChange(val) {
      if (this.$route.participantId !== val) {
        this.$router.replace(
          `/test/${this.$route.params.id}/participant/${val.value}/recording`
        );
      }
    },
  },
  computed: {
    ...mapState({
      testState: (state) => state.test,
    }),
  },
};
</script>
